export function LogoMark({ size = 36, className = "" }) {
  return (
    <img
      src="/assets/logo.jpg"
      alt="GrooveMusic logo"
      width={size}
      height={size}
      className={`rounded-full object-cover shadow-[0_0_18px_rgba(88,101,242,0.35)] ${className}`}
      style={{ width: size, height: size }}
      data-testid="logo-mark"
    />
  );
}

export function Wordmark({ className = "" }) {
  return (
    <span className={`font-display font-800 tracking-tight text-white ${className}`} style={{ fontWeight: 800 }}>
      Groove<span className="text-blurple">Music</span>
    </span>
  );
}
